import {combineReducers} from 'redux';
import {
  SET_ADDRESS_LINE_1,
  SET_ADDRESS_LINE_2,
  SET_CITY,
  SET_STATE,
  SET_POSTAL_CODE,
  SET_ADDRESS_LINE_1_ERRORS,
  SET_ADDRESS_LINE_2_ERRORS,
  SET_CITY_ERRORS,
  SET_STATE_ERRORS,
  SET_POSTAL_CODE_ERRORS,
  SET_ADDRESS_ERRORS
} from '../actionTypes/address';


export const setAddressLine1 = (value) => ({
  type: SET_ADDRESS_LINE_1,
  value: value
});

export const setAddressLine2 = (value) => ({
  type: SET_ADDRESS_LINE_2,
  value: value
});

export const setCity = (value) => ({
  type: SET_CITY,
  value: value
});

export const setState = (value) => ({
  type: SET_STATE,
  value: value
});

export const setPostalCode = (value) => ({
  type: SET_POSTAL_CODE,
  value: value
});


/*** Error setters ***/

export const setAddressLine1Errors = (errors) => ({
  type: SET_ADDRESS_LINE_1_ERRORS,
  errors: errors
});

export const setAddressLine2Errors = (errors) => ({
  type: SET_ADDRESS_LINE_2_ERRORS,
  errors: errors
});

export const setCityErrors = (errors) => ({
  type: SET_CITY_ERRORS,
  errors: errors
});

export const setStateErrors = (errors) => ({
  type: SET_STATE_ERRORS,
  errors: errors
});

export const setPostalCodeErrors = (errors) => ({
  type: SET_POSTAL_CODE_ERRORS,
  errors: errors
});

export const setErrors = (errors) => ({
  type: SET_ADDRESS_ERRORS,
  errors: errors
});


// WEBPACK FOOTER //
// ./src/actions/address.js